import { EntityType } from 'common/enums/entity-enums.js';
import { PossibleEDMDTables, RecognisedDataCatalogues } from 'common/enums/known-data-enums.js';

const multipleTablesCatalogues: Partial<Record<RecognisedDataCatalogues, boolean>> = {
  [RecognisedDataCatalogues.SurveyRuns]: true,
  [RecognisedDataCatalogues.ToolsIPMfiles]: true,
  [RecognisedDataCatalogues.GeomagneticParametersDefinition]: true,
  [RecognisedDataCatalogues.HoleSize]: true,
  [RecognisedDataCatalogues.CovarianceMatrixTotal]: true,
};

const multipleTablesTypes: Partial<Record<EntityType, boolean>> = {
  [PossibleEDMDTables.SurveyRun]: true,
  [PossibleEDMDTables.IPMFile]: true,
  [PossibleEDMDTables.GeomagneticParameters]: true,
  [PossibleEDMDTables.HoleSize]: true,
  [PossibleEDMDTables.CovarianceMatrix]: true,
};

const objectsWithAssociatedData: Partial<Record<EntityType, boolean>> = {
  [PossibleEDMDTables.SurveyRun]: true,
  [PossibleEDMDTables.SurveyProgram]: true,
};

export const isMultipleTableCatalogue = (type: RecognisedDataCatalogues) => multipleTablesCatalogues[type] || false;

export const isMultipleTableType = (type: EntityType) => multipleTablesTypes[type] || false;
export const hasAssociatedData = (type: EntityType) => objectsWithAssociatedData[type] || false;
